import axios from 'axios'
import MintUI from 'mint-ui'

export default {
    mobile_get: (url, params, config) => {
        return new Promise((resolve, reject) => {
            MintUI.Indicator.open(`加载中...`)
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            axios.get(url, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config, { params: params })).then((response) => {
                MintUI.Indicator.close()
                if (_.has(response, `status`)) {
                    if (response.status === 200) {
                        return resolve(response.data)
                    } else {
                        return reject(response.msg)
                    }
                } else {
                    resolve(response)
                }
            }).catch(e => {
                MintUI.Indicator.close()
                if (e && e.data && e.status == `600`) {
                    MintUI.Toast({
                        message: e.data && e.data.detail,
                        position: `middle`,
                        duration: 2000
                    })
                } else if (e && e.data) {
                    MintUI.Toast({
                        message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`,
                        position: `middle`,
                        duration: 2000
                    })
                }
                return reject(e)
            })
        })
    },
    mobile_post: (url, data, config, showloading = true) => {
        return new Promise((resolve, reject) => {
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }

            if (showloading) {
                MintUI.Indicator.open(`加载中...`)
            }

            axios.post(url, data, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config))
                .then((response) => {
                    if (showloading) {
                        MintUI.Indicator.close()
                    }
                    if (_.has(response, `status`)) {
                        if (response.status === 200) {
                            return resolve(response.data)
                        } else {
                            return reject(response.msg)
                        }
                    } else {
                        resolve(response)
                    }
                }).catch(e => {
                    if (showloading) {
                        MintUI.Indicator.close()
                    }
                    if (e && e.data && e.status == `600`) {
                        MintUI.Toast({
                            message: e.data && e.data.detail,
                            position: `middle`,
                            duration: 2000
                        })
                    } else if (e && e.data) {
                        MintUI.Toast({
                            message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`,
                            position: `middle`,
                            duration: 2000
                        })
                    }
                    return reject(e)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/Mobile/mobile_axios.js